import * as Immutable from 'immutable';
import * as React from 'react';
import CenterButtonContainer from '../_containers/CenterButtonContainer';
import RulersButtonContainer from '../_containers/RulersButtonContainer';
import GridButtonContainer from '../_containers/GridButtonContainer';
import OverlayButtonContainer from '../_containers/OverlayButtonContainer';

export type Props = {
	flexDirection: string
	withBottomBorder?: boolean
}

export default class DocumentActionButtons extends React.Component<Props> {
	render = () => {
		return <div className={this.props.flexDirection + " action-buttons " + (this.props.withBottomBorder ? "with-border" : "" )} >
			<CenterButtonContainer />
			<RulersButtonContainer />
			<GridButtonContainer />
			<OverlayButtonContainer />
		</div>
	}
}